import { useTranslation } from "react-i18next";
import { Link } from "@material-ui/core";
import { FileItemSubtitleContainer } from "./styled";
import { LoadedFile } from "../../types";

interface FileItemSubtilteProps {
  file: LoadedFile;
  onFileSelect: () => void;
}

export default function FileItemSubtitle({
  file,
  onFileSelect,
}: FileItemSubtilteProps) {
  const { t } = useTranslation("accounts");

  return (
    <FileItemSubtitleContainer>
      <span>
        {`${file.items.length} accounts loaded.`}
        {!!file.items.length && (
          <Link onClick={onFileSelect}>
            {t("importAccountsModal.files.showAccountsLink")}
          </Link>
        )}
      </span>
    </FileItemSubtitleContainer>
  );
}
